// base
import React from 'react';

// constants
import { PKG_2 } from 'constants/const';

// libraries
import { Helmet } from 'react-helmet-async';

interface SEOMetaTagProps {
  pkgNo: string;
}

export const SEOMetaTag: React.FC<SEOMetaTagProps> = ({ pkgNo }) => (
  <Helmet defer>
    <>
      {pkgNo === PKG_2 && (
        <>
          <meta name="application-name" content="4S GSCA FGIP" />
          <meta
            name="description"
            content="IoT-integrated safety management platform for high-risk construction sites, providing comprehensive oversight through real-time data from personal and monitoring devices. Enables swift risk detection, emergency management, and data-driven safety insights throughout the entire operation life cycle."
          />
          <meta
            name="keywords"
            content="safety management, RFID, IoT, construction sites, real-time monitoring, risk detection, emergency management, safety insights"
          />
          <meta name="author" content="GSIL" />
          <meta name="category" content="Construction Safety" />

          <link rel="icon" href="/favicon-gs.ico" />
          <meta name="theme-color" content="#3DAC90" />

          <meta property="og:title" content="4S GSCA FGIP" />
          <meta
            property="og:description"
            content="IoT-integrated safety management platform for high-risk construction sites, providing comprehensive oversight through real-time data from personal and monitoring devices. Enables swift risk detection, emergency management, and data-driven safety insights throughout the entire operation life cycle."
          />
          <meta property="og:site_name" content="4S GSCA FGIP" />

          <style type="text/css">{`
            :root {
                  /* Primary Colors */
                  --color-primary-blue: #3DAC90;
                  --color-secondary-blue: #27704D;
                  --color-charcoal-black: #2f2f35;
                  --color-medium-gray: #585959;
                  --color-light-gray: #8a8a8a;

                  /* Gradient */
                  --main-gradient: linear-gradient(0deg, #80BD2E -121.15%, #63B646 -75.12%, #2EA871 14.54%, #0D9F8C 84.81%, #009C96 121.15%);

                  /* Additional Colors */
                  --color-pale-gray: #dadada;
                  --color-ice-blue: #eef1fa;
                  --color-off-white: #f8f8f8;
                  --color-footer-gray: #7b7c7c;
                  --color-light-gray: #d9d9d9;
                  --color-text-gray: #a4a7a7;

                  --color-border-light-gray: #e6e6e6;

                  /** Default Colors */
                  --color-white: #ffffff;
                  --color-black: #000000;
                  --color-text-main: #2f2f35;

                  /* Alert Color */
                  --color-alert-red: #de3e47;

                  --color-success: #6db983;
                  --color-warning: #de3e47;

                  --color-table-header: #222222;
                  --color-update-gray: #8b8b8b;

                  --color-menu-selected: #e66d12;
                }
          `}</style>

          <title>4S GSCA FGIP</title>
        </>
      )}

      {pkgNo !== PKG_2 && (
        <>
          <meta name="application-name" content="FGIP 4S RFID" />
          <meta
            name="description"
            content="Integrated safety management platform for high-risk construction sites, providing comprehensive oversight through real-time data from personal and monitoring devices. Enables swift risk detection, emergency management, and data-driven safety insights throughout the entire operation life cycle."
          />
          <meta
            name="keywords"
            content="safety management, RFID, IoT, construction sites, real-time monitoring, risk detection, emergency management, safety insights"
          />
          <meta name="author" content="GSIL" />
          <meta name="category" content="Construction Safety" />

          <link rel="icon" href="/favicon-ss.ico" />
          <meta name="theme-color" content="#2e4cc2" />

          <meta property="og:title" content="FGIP 4S RFID" />
          <meta
            property="og:description"
            content="Integrated safety management platform for high-risk construction sites, providing comprehensive oversight through real-time data from personal and monitoring devices. Enables swift risk detection, emergency management, and data-driven safety insights throughout the entire operation life cycle."
          />
          <meta property="og:site_name" content="FGIP 4S RFID" />

          <style type="text/css">{`
            :root {
                  /* Primary Colors */
                  --color-primary-blue: #2e4cc2;
                  --color-secondary-blue: #3e64bc;
                  --color-charcoal-black: #2f2f35;
                  --color-medium-gray: #585959;
                  --color-light-gray: #8a8a8a;

                  /* Gradient */
                  --main-gradient: linear-gradient(212.65deg, #3c5ae2 -13.89%, #022495 118.24%);

                  /* Additional Colors */
                  --color-pale-gray: #dadada;
                  --color-ice-blue: #eef1fa;
                  --color-off-white: #f8f8f8;
                  --color-footer-gray: #7b7c7c;
                  --color-light-gray: #d9d9d9;
                  --color-text-gray: #a4a7a7;

                  --color-border-light-gray: #e6e6e6;

                  /** Default Colors */
                  --color-white: #ffffff;
                  --color-black: #000000;
                  --color-text-main: #2f2f35;

                  /* Alert Color */
                  --color-alert-red: #de3e47;

                  --color-success: #6db983;
                  --color-warning: #de3e47;

                  --color-table-header: #222222;
                  --color-update-gray: #8b8b8b;

                  --color-menu-selected: #2e4cc2;
                }
          `}</style>

          <title>FGIP 4S RFID</title>
        </>
      )}
    </>
  </Helmet>
);
